import _omitBy from 'lodash/omitBy'
import _isNull from 'lodash/isNull'
import { checkStatus, json, RxCustomerAPI, CustomerAPI } from '@driftt/dapper'
import { captureException } from 'utils/SentryHelpers'
import { Profile } from './models'

const filterNull = (data) => _omitBy(data, _isNull)

function parseProfile(data) {
  const { visibility, ...profile } = filterNull(data)
  return {
    visibility,
    profile: Profile(profile),
  }
}

export const api = {
  get(userId) {
    return RxCustomerAPI.get(`/users/${userId}/profile`)
      .checkStatus()
      .mapResponse(parseProfile)
  },

  fetch(userId) {
    return CustomerAPI.get(`/users/${userId}/profile`)
      .then(checkStatus)
      .then(json)
      .then(parseProfile)
      .catch(captureException)
  },

  update(userId, operations) {
    return CustomerAPI.patch(`/users/${userId}/profile`, operations)
      .then(checkStatus)
      .then(json)
      .then(parseProfile)
  },

  checkUserHandle(handle) {
    return CustomerAPI.head(`/users/handle_check`, { handle })
  },

  checkGlobalHandle(globalHandle) {
    return CustomerAPI.head(`/users/handle_check`, { globalHandle })
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/profile/api.js